import { render } from "./SamplesAndAssesments.vue?vue&type=template&id=7134324a&scoped=true&ts=true"
import script from "./SamplesAndAssesments.vue?vue&type=script&lang=ts"
export * from "./SamplesAndAssesments.vue?vue&type=script&lang=ts"

import "./SamplesAndAssesments.vue?vue&type=style&index=0&id=7134324a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7134324a"]])

export default __exports__